import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { ConfigurationStatus, useMicrosoftConfiguration } from './useMicrosoftConfiguration';

export function PasswordAuthGate({ children }: { children: React.ReactNode }) {
  const { configuration, failed, retry } = useMicrosoftConfiguration();
  if (!configuration || failed) return <ConfigurationStatus failed={failed} retry={retry} />;
  if (configuration.ssoOnly) return <Redirect to={{ pathname: '/login', state: { ssoOnly: true } }} />;
  return <>{children}</>;
}
